function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import T, { createContext as P, Fragment as m, useContext as s, useEffect as d, useMemo as g, useRef as R, useState as E } from "react";
import { createPortal as C } from "react-dom";
import { useEvent as c } from '../../hooks/use-event.js';
import { useIsoMorphicEffect as y } from '../../hooks/use-iso-morphic-effect.js';
import { useOnUnmount as H } from '../../hooks/use-on-unmount.js';
import { useOwnerDocument as x } from '../../hooks/use-owner.js';
import { useServerHandoffComplete as b } from '../../hooks/use-server-handoff-complete.js';
import { optionalRef as h, useSyncRefs as L } from '../../hooks/use-sync-refs.js';
import { usePortalRoot as O } from '../../internal/portal-force-root.js';
import { env as A } from '../../utils/env.js';
import { forwardRefWithAs as G, render as M } from '../../utils/render.js';

function F(p) {
  var n = O(),
      l = s(_),
      e = x(p),
      _E = E(function () {
    if (!n && l !== null || A.isServer) return null;
    var t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
    if (t) return t;
    if (e === null) return null;
    var r = e.createElement("div");
    return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
  }),
      _E2 = _slicedToArray(_E, 2),
      a = _E2[0],
      o = _E2[1];

  return d(function () {
    a !== null && (e != null && e.body.contains(a) || e == null || e.body.appendChild(a));
  }, [a, e]), d(function () {
    n || l !== null && o(l.current);
  }, [l, o, n]), a;
}

var U = m;

function N(p, n) {
  var l = p,
      e = R(null),
      a = L(h(function (u) {
    e.current = u;
  }), n),
      o = x(e),
      t = F(e),
      _E3 = E(function () {
    var u;
    return A.isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
  }),
      _E4 = _slicedToArray(_E3, 1),
      r = _E4[0],
      i = s(f),
      v = b();

  return y(function () {
    !t || !r || t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r));
  }, [t, r]), y(function () {
    if (r && i) return i.register(r);
  }, [i, r]), H(function () {
    var u;
    !t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((u = t.parentElement) == null || u.removeChild(t)));
  }), v ? !t || !r ? null : C(M({
    ourProps: {
      ref: a
    },
    theirProps: l,
    defaultTag: U,
    name: "Portal"
  }), r) : null;
}

var S = m,
    _ = P(null);

function j(p, n) {
  var l = p.target,
      e = _objectWithoutProperties(p, ["target"]),
      o = {
    ref: L(n)
  };

  return T.createElement(_.Provider, {
    value: l
  }, M({
    ourProps: o,
    theirProps: e,
    defaultTag: S,
    name: "Popover.Group"
  }));
}

var f = P(null);

function ee() {
  var p = s(f),
      n = R([]),
      l = c(function (o) {
    return n.current.push(o), p && p.register(o), function () {
      return e(o);
    };
  }),
      e = c(function (o) {
    var t = n.current.indexOf(o);
    t !== -1 && n.current.splice(t, 1), p && p.unregister(o);
  }),
      a = g(function () {
    return {
      register: l,
      unregister: e,
      portals: n
    };
  }, [l, e, n]);
  return [n, g(function () {
    return function (_ref) {
      var t = _ref.children;
      return T.createElement(f.Provider, {
        value: a
      }, t);
    };
  }, [a])];
}

var D = G(N),
    I = G(j),
    te = Object.assign(D, {
  Group: I
});
export { te as Portal, ee as useNestedPortals };